module.exports = __webpack_public_path__ + "static/media/nodata.c2b47a52.png";